import { CellContext, ColumnDef } from "@tanstack/react-table";
import React from "react";

type Props = CellContext<any, unknown>;

const NACell: React.FC<Props> = (props) => {
  const { renderValue } = props;
  return <>{renderValue() ?? "N/A"}</>;
};

export default NACell;
